<template>
  <div :class="[item.contentType == 'image' || item.contentType == 'video' ? '' : 'message-cont', +item.status === 2 ? 'offline' : '', item.type === '14' ? 'message-cont-welcome-card' : '']">
    
    <!-- 消息引用区域 [[ -->
    <div v-if="item.messageReference" class="reference-wrap" @click="handlePreview(item)">
      <dl v-if="item.messageReference.hasRevoked">
        <dt>{{item.messageReference.refSenderName || item.messageReference.refSenderId}}：</dt>
        <dd>{{$t('meassageHasBeenRevoked')}}</dd>
      </dl>
      <dl v-else>
        <dt>{{item.messageReference.refSenderName || item.messageReference.refSenderId}}：</dt>
        <!-- 纯文本 [[ -->
        <dd v-if="item.messageReference.refContentType == 'text'">
          <div :class="{'isRichText': checkRichText(item.messageReference.refContent)}" v-html="replaceFace(item.messageReference.refContent)"></div>
        </dd>
        <!-- 纯文本 ]] -->
        <!-- 图片 [[ -->
        <dd v-else-if="item.messageReference.refContentType == 'image'">
          <div>[{{$t('img')}}]</div>
        </dd>
        <!-- 图片 ]] -->
        <!-- 视频 [[ -->
        <dd v-else-if="item.messageReference.refContentType == 'video'">
          <div>[{{$t('video')}}]</div>
        </dd>
        <!-- 视频 ]] -->
        <!-- 语音 [[ -->
        <dd v-else-if="item.messageReference.refContentType == 'voice'">
          <div>[{{$t('voice')}}]</div>
        </dd>
        <!-- 语音 ]] -->
        <!-- 文件 [[ -->
        <dd v-else-if="item.messageReference.refContentType == 'document'">
          <a :href="item.messageReference.refContent" download target="__blank" style="text-decoration: underline;">{{$t('clickDownload')}} > {{item.messageReference.refFileName}}</a>
        </dd>
        <!-- 文件 ]] -->
      </dl>
    </div>
    <!-- 消息引用区域 ]] -->
    <img v-if="item.contentType == 'image'" class="content-img" :src="item.content" style="max-width:130px; max-height: 136px"/>
    <video v-else-if="item.contentType == 'video'" :src="item.content" style="width: 200px" class="content-video" controls="controls">{{$t('doseNotsupportVideo')}}</video>
    <div class="voice-page" v-else-if="item.contentType == 'voice'">
      <audio :src="item.content"  class="voice-audio" controls="controls"></audio>
    </div>
    <div class="ellipsis" v-else-if="item.contentType == 'document' || item.contentType == 'other'" >
      <a :href="item.content" style="color: #043ff7" download>
        <span style="border-bottom: 1px solid #043ff7;">{{$t('clickDownload')}} &gt;{{item.fileName}}</span>
      </a>
    </div>
    <div class="welcome-card" :style="{ fontSize: fontSize + 'px' }" v-else-if="item.type === '14'">
      <div style="font-size: 0;display: flex;justify-content: center;position: relative;">
        <div class="semicircle"></div>
        <div class="avatar">
          <img :src="handlerPicture(item.senderPicture)" alt="">
        </div>
      </div>
      <div class="welcome-card-title">{{ handlerContent(item.content, 1) }}</div>
      <div>{{ handlerContent(item.content, 2) }}</div>
    </div>
    <div v-else :style="{ fontSize: fontSize + 'px' }" v-html="replaceFace(item.content)"></div>
      <!-- 消息详情 [[]] -->
      <referenceMessageInfoModal ref="msgInfoModal"/>
      <!-- 消息详情 [[]] -->
  </div>
</template>
<script>
import FaceObjConfig from '@/assets/data/faceObjConfig'
import { mapGetters, mapMutations, mapState } from 'vuex'
import ajax from '@/ajax/axios-ajax.js'
import apis from '@/apis/index.js'
import referenceMessageInfoModal from './referenceMessageInfoModal'

export default {
  components: {
    referenceMessageInfoModal
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      fontSize: 'fontSize'
    }),
    ...mapState({
      currentGroup: 'currentGroup',
      channelGroupVoList: 'channelGroupVoList'
    })
  },
  methods: {
    ...mapMutations({
      onlyUpdateGroupStatus: 'onlyUpdateGroupStatus'
    }),
    replaceFace: FaceObjConfig.replaceFace,
    checkRichText(content) {
      let reg = /<[^>]+>/g
      let result = reg.test(content)
      return result
    },
    handlerContent(data, type) {
      let content = JSON.parse(data)
      return type === 1 ? content.welcomeCardTitle : content.welcomeCardContent
    },
    handlerPicture(picture) {
      return picture || require('@/assets/img/customer-img.png')
    },
    // 退出排队
    exitQueue(tenantId, groupId, visitorId, accessLogId) {
      let params = { tenantId, groupId, visitorId, accessLogId }
      this.$confirm({
        title: this.$t('exitQueue'),
        okText: this.$t('OK'),
        cancelText: this.$t('CANCEL'),
        onOk: () => {
          ajax.get(apis.chat.getout, {params}).then((res) => {
            if (res.success) {
              this.$message.success(this.$t('exitSuccess'))
              this.onlyUpdateGroupStatus({ groupId: this.currentGroup.groupId, status: '3' })
            } else {
              this.$message.error(this.$t('exitFailed'))
            }
          })
        }
      })
    },  
    // 预览引用消息
    handlePreview (v) {
      this.$refs.msgInfoModal.setModalVisible('open', v)
    }
  },
  mounted () {
    window.exitQueue = this.exitQueue
  }
}
</script>
<style scoped lang="less">
  .message-cont {
    max-width: 400px;
    min-height: 30px;
    padding: 6px 10px;
    border-radius: 5px;
    background-color: #ffffff;
    margin-top: 5px;
    word-break: break-word;
    box-shadow: 0px 4px 16px 0px rgba(194, 207, 229, 0.1);
    &.offline{
      background-color: #ffb419 !important;
    }
    /deep/img{
      max-width: 130px;
    }
  }
  .customerMessage{
    .reference-wrap{
      border-bottom: 1px solid #e5e5e5;
      dl{
        border-left: 2px solid #e5e5e5;
      }
    }
  }
  .reference-wrap{
    cursor: pointer;
    margin-bottom: 12px;
    border-bottom: 1px solid #BDD7ED;
    dl{
      border-left: 2px solid #BAD6EE;
      padding-left: 10px;
      font-size: 13px;
      color: #999999;
      margin-bottom: 8px;
      dd{ 
        /deep/p, /deep/div {
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        
        /deep/p.isRichText, /deep/div.isRichText{
          max-height: 60px;
          overflow: hidden;
        }
      }
    }
  }
  
  .message-cont-welcome-card {
    border: 2px solid #ffffff;
    box-shadow: 0px 4px 16px 0px rgba(194, 207, 229, 0.1);
    background: linear-gradient(180deg, #f2f4f9 0%, #ffffff 100%);
    padding-bottom: 12px;
  }

  .welcome-card {
    min-width: 193px;
    max-width: 300px;
    text-align: center;
    margin-top: -28px;
    font-size: 14px;
    font-weight: bold;
    color: #303D54;

    .circle {
      height: 40px;
      width: 40px;
      display: inline-block;
      border-radius: 50%;
      background: #ffffff;
      overflow: hidden;
    }

    .avatar {
      display: inline-block;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      background: linear-gradient(180deg, #f2f4f9 0%, #ffffff 100%);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .welcome-card-title {
      margin-top: 8px;
      margin-bottom: 4px;
    }
    .semicircle {
      height: 20px;
      width: 44px;
      overflow: hidden;
      position: absolute;
      &:before {
        display: inline-block;
        width: 44px;
        height: 40px;
        border-radius: 100%;
        content: '';
        box-sizing: border-box;
        border: solid 2px #ffffff;
      }
    }
  }
</style>
